"use client";

import { useSelection } from "@trydig/centra/client";
import { useModal } from "~/lib/hooks/useModal";
import { selectionItemsByGroup } from "~/lib/utils/selectionItemsByGroup";

export const useCart = () => {
	const { data: selection, isLoading } = useSelection();
	const modal = useModal("cart", () => {}, true);

	return {
		groupItems: selectionItemsByGroup(selection?.selection?.items),
		items: selection?.selection?.items,
		itemCount: selection?.selection?.items?.length || 0,
		isLoading,
		modal,
		totalQuantity: selection?.selection?.totals?.totalQuantity,
		total: selection?.selection?.totals?.itemsTotalPrice,
		shipping: selection?.selection?.totals?.shippingPrice,
		shippingAsNumber: selection?.selection?.totals?.shippingPriceAsNumber,
		totalAsNumber: selection?.selection?.totals?.itemsTotalPriceAsNumber,
		grandTotal: selection?.selection?.totals?.grandTotalPrice,
		grandTotalAsNumber: selection?.selection?.totals?.grandTotalPriceAsNumber,
		grandTotalPriceTax: selection?.selection?.totals?.grandTotalPriceTax,
		grandTotalPriceTaxAsNumber: selection?.selection?.totals?.grandTotalPriceTaxAsNumber,
		discount: selection?.selection?.discounts,
	};
};

export type CartItem = NonNullable<ReturnType<typeof useCart>["items"]>[number];

export type CartHook = ReturnType<typeof useCart>;
